import { Component, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer } from '@angular/forms';

@Component({
    selector: 'risk-profil-company-second-part',
    templateUrl: './risk-profil-company-second-part.component.html',
    styleUrls: ['./risk-profil-company-second-part.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
    standalone: false
})
export class RiskProfilCompanySecondPartComponent implements OnInit {
  options = [
    {
      label: 'Oui',
      value: 'YES',
    },
    {
      label: 'Non',
      value: 'NO',
    },
  ];
  constructor() {}

  ngOnInit() {}
}
